import { useContext } from 'react';
import { AttentionChartsDataContext } from '../contexts/AttentionChartsDataContext';

export const useAttentionChartsDataContext = () => {
    return useContext(AttentionChartsDataContext);
};
